<div *ngIf="displayCard && (permissionDenied$$ | async) === false" class="crm-uniqueness-suggestion">
  <ng-container *ngIf="objectCardInfo$ | async as cardInfo; else loading">
    <crm-association-card [cardData]="cardInfo" [showActionsMenu]="false"></crm-association-card>
  </ng-container>
  <ng-template #loading>
    <glxy-loading-spinner [inline]="false"></glxy-loading-spinner>
  </ng-template>
</div>
<div *ngIf="displayCard && (permissionDenied$$ | async) === true">
  <glxy-error>
    {{
      'CONTACT.STANDARD_FIELD_RULES.UNIQUE_FIELD_VALUE.PERMISSION_DENIED'
        | translateByObjectType: objectType : { label: label.toLowerCase() }
    }}
  </glxy-error>
</div>
